import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { DataGrid, GridColumnProps, StatusChip, StatusType,YesNoChip } from '@roc/ui';
import { makeStyles } from '@material-ui/core/styles';
import { formatDate } from '@roc/feature-utils';
import { useStore } from '@roc/client-portal-shared/hooks';
import { formatPhoneNumber } from '@roc/ui/utils';

const useStyles = makeStyles(theme => ({
  paginationBar: {
    border: 'none',
    borderTop: '1px solid #eee',
    padding: 8,
    background: '#fafafa',
  },
}));

export const MyReferralsDataGrid = observer(() => {
  const classes = useStyles();
  const { referralsStore } = useStore();
  const { gridStore } = referralsStore;

  useEffect(() => {
    gridStore.resetAndFetchGridData();
  }, []);

  const onSortChanged = params => {
    const sortModel = params.api.getSortModel();
    gridStore.setSortModel(sortModel);
  };

  const columns: GridColumnProps[] = [
    {
      field: 'fullName',
      headerName: 'Full Name',
      minWidth: 240
    },
    {
      field: 'email',
      headerName: 'Email',
      minWidth: 240
    },
    {
      field: 'phone',
      headerName: 'Phone Number',
      width: 120,
      cellRenderer: 'phoneCellRenderer'
    },
    {
      field: 'submittedDate',
      headerName: 'Referral Submitted Date',
      maxWidth: 240,
      cellRenderer: 'dateCellRenderer',
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 118,
      cellRenderer: 'statusCellRenderer',
    },
    {
      field: 'lenderName',
      headerName: 'Originator Name',
      minWidth: 125
    },
    {
      field: 'loanId',
      headerName: 'Loan Id',
      minWidth: 80
    },
    {
      field: 'fundedDate',
      headerName: 'Funded Date',
      minWidth: 200,
      cellRenderer: 'dateCellRenderer',
    },
    {
      field: 'estimatedPaymentDate',
      headerName: 'Estimated Payment Date',
      minWidth: 200,
      cellRenderer: 'dateCellRenderer',
    },
    {
      field: 'achBankInfo',
      headerName: 'ACH Bank Info',
      minWidth: 75,
      cellRenderer: 'statusAchCellRenderer',
    },
    {
      field: 'referredBy',
      headerName: 'Referred By',
      width: 120,
    },
  ];

  return (
    <DataGrid
      columns={columns}
      rows={gridStore.gridData.data.rows}
      frameworkComponents={{
        dateCellRenderer: ({ value }) => formatDate(value, 'MM/dd/yyyy') ?? null,
        statusCellRenderer: ({ value }) =>
          value ? (
            <StatusChip statusType={StatusType.REFERRAL} label={value} variant={'filled'} />
          ) : null,
        statusAchCellRenderer: ({ value }) =>
          value ? (
            <YesNoChip value={value} />
          ) : null,
        phoneCellRenderer: ({ value }) => formatPhoneNumber(value),
      }}
      onSortChanged={onSortChanged}
      isLoading={gridStore.isLoading}
      sortModel={gridStore.sortModel}
      filterModel={gridStore.filterModel}
      paginationData={gridStore.gridData.meta}
      paginationBarClassName={classes.paginationBar}
      setPageNumber={gridStore.setPageNumber}
      domLayout='autoHeight'
    />
  )
});
